import { render, staticRenderFns } from "./autoNumber.vue?vue&type=template&id=28dfd0cd&scoped=true"
import script from "./autoNumber.vue?vue&type=script&lang=js"
export * from "./autoNumber.vue?vue&type=script&lang=js"
import style0 from "./autoNumber.vue?vue&type=style&index=0&id=28dfd0cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dfd0cd",
  null
  
)

export default component.exports